module.exports = __webpack_public_path__ + "static/img/img-main-award.75f6867.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/img-main-award.png
// module id = JTyP
// module chunks = 18